export const addQueryStringToUrl = (url: string, queryString: string) => {
  if (!queryString || url.endsWith(queryString)) {
    return url
  }

  return `${url}${queryString}`
}
